import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
 
// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    lineHeight: 1.5,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    textDecoration: 'underline',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 10,
  },
  paragraph: {
    marginBottom: 10,
  },
  listItem: {
    marginLeft: 20,
    marginBottom: 5,
  },
  subListItem: {
    marginLeft: 40,
    marginBottom: 5,
  },
  signatureSection: {
    marginTop: 40,
    paddingTop: 20,
    borderTop: '1px solid #000',
  },
  signatureLine: {
    marginTop: 30,
  },
  signatureLabel: {
    marginTop: 5,
  },
  divider: {
    borderBottom: '1px solid #000',
    marginVertical: 20,
  },
  attachmentTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 20,
    marginBottom: 10,
  },
  attachmentItem: {
    marginLeft: 20,
    marginBottom: 5,
  },
});
 
const MOUPDF = ({ vendorData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View>
        <Text style={styles.title}>MEMORANDUM OF UNDERSTANDING</Text>
        
        <Text style={styles.paragraph}>
          This Memorandum of Understanding ("MoU") is entered into on{' '}
          <Text style={{fontWeight: 'bold'}}>{new Date().toLocaleDateString()}:</Text>
        </Text>
        
        <Text style={{...styles.paragraph, fontWeight: 'bold'}}>BY AND BETWEEN</Text>
        
        <Text style={styles.paragraph}>
          <Text style={{fontWeight: 'bold'}}>Drone Planet</Text>, a Startup Stairs Pvt. Ltd., a company registered under
          the laws of India, with its registered office at Plot 251, Phase IV, Udyog Vihar, Gurugram
          (hereinafter referred to as "Marketplace" or "First Party")
        </Text>
        
        <Text style={{textAlign: 'center', marginVertical: 10}}>AND</Text>
        
        <Text style={styles.paragraph}>
          <Text style={{fontWeight: 'bold'}}>{vendorData?.modelNo || '[Vendor Name]'}</Text>, a business entity registered
          under the laws of India, with its registered office at {vendorData?.address || '[Vendor Address]'}
          (hereinafter referred to as "Vendor" or "Second Party")
        </Text>
        
        <Text style={styles.paragraph}>
          Both the First Party and Second Party are herein collectively referred to as the "Parties" and
          individually as a "Party".
        </Text>
 
        <Text style={styles.sectionTitle}>1. PURPOSE</Text>
        <Text style={styles.paragraph}>
          The purpose of this MoU is to establish the terms and conditions under which the Vendor shall sell
          drones and spare parts on the Marketplace, while the Marketplace shall facilitate the sale of these
          products through its platform.
        </Text>
 
        <Text style={styles.sectionTitle}>2. DURATION OF THE MOU</Text>
        <Text style={styles.paragraph}>
          This MoU shall become effective as of the date above and shall continue for [Specify Duration] year(s),
          unless terminated earlier by either party with thirty (30) days' written notice.
        </Text>
 
        <Text style={styles.sectionTitle}>3. SCOPE OF THE AGREEMENT</Text>
        <Text style={styles.listItem}>
          a. Products: Sale of drones and spare parts.
        </Text>
        <Text style={styles.listItem}>
          b. Vendor: Compliance with Indian laws, certifications, approvals.
        </Text>
        <Text style={styles.listItem}>
          c. Marketplace: Provide platform access, marketing, and support.
        </Text>
 
        <Text style={styles.sectionTitle}>4. COMMISSION RATES</Text>
        <Text style={styles.listItem}>
          a. Drones: 10% commission
        </Text>
        <Text style={styles.listItem}>
          b. Spare parts: 15% commission
        </Text>
        <Text style={styles.listItem}>
          c. Payout: Within 15 business days post-sale
        </Text>
        <Text style={styles.listItem}>
          d. Monthly processing
        </Text>
        <Text style={styles.listItem}>
          e. Dashboard access for transparency
        </Text>
 
        <Text style={styles.sectionTitle}>5. VENDOR OBLIGATIONS</Text>
        <Text style={styles.paragraph}>
          Accurate listings, legal compliance, timely dispatch, after-sales service, and adequate stock maintenance.
        </Text>
 
        <Text style={styles.sectionTitle}>6. MARKETPLACE OBLIGATIONS</Text>
        <Text style={styles.paragraph}>
          Platform listing, promotional support, customer service, and product approval rights.
        </Text>
 
        <Text style={styles.sectionTitle}>7. PRODUCT LISTINGS AND PRICING</Text>
        <Text style={styles.paragraph}>
          Vendor controls pricing, Marketplace may run promotions with prior notice of changes required.
        </Text>
 
        <Text style={styles.sectionTitle}>8. RETURNS AND REFUNDS</Text>
        <Text style={styles.paragraph}>
          Vendor adheres to return policy, bears return costs unless otherwise agreed in writing.
        </Text>
 
        <Text style={styles.sectionTitle}>9. DELIVERY TERMS</Text>
        <Text style={styles.paragraph}>
          Vendor responsible for packaging, shipping, tracking, delivery updates, and refund obligations.
        </Text>
 
        <Text style={styles.sectionTitle}>10. TERMINATION</Text>
        <Text style={styles.paragraph}>
          30-day notice for termination. Immediate termination for breach or unlawful activity.
        </Text>
 
        <Text style={styles.sectionTitle}>11. CONFIDENTIALITY</Text>
        <Text style={styles.paragraph}>
          Confidential info includes financials, specs, and customer data. Survives 2 years post-termination.
        </Text>
 
        <Text style={styles.sectionTitle}>12. DISPUTE RESOLUTION</Text>
        <Text style={styles.paragraph}>
          Negotiation, then arbitration under the Indian Arbitration Act. Venue: New Delhi. Language: English.
        </Text>
 
        <Text style={styles.sectionTitle}>13. GOVERNING LAW</Text>
        <Text style={styles.paragraph}>
          Governing Law: India
        </Text>
 
        <Text style={styles.sectionTitle}>14. MISCELLANEOUS</Text>
        <Text style={styles.listItem}>
          a. Written amendments only.
        </Text>
        <Text style={styles.listItem}>
          b. Entire agreement.
        </Text>
        <Text style={styles.listItem}>
          c. No joint venture or partnership.
        </Text>
 
        <Text style={styles.sectionTitle}>15. SIGNATURES</Text>
        <Text style={styles.paragraph}>
          IN WITNESS WHEREOF, the Parties have executed this MoU on the date mentioned above.
        </Text>
 
        <View style={styles.signatureSection}>
          <Text style={{fontWeight: 'bold'}}>For Startup Stairs Pvt. Ltd.</Text>
          <Text style={styles.signatureLabel}>Name:</Text>
          <Text style={styles.signatureLabel}>Title:</Text>
          <Text style={styles.signatureLabel}>Date: {new Date().toLocaleDateString()}</Text>
        </View>
 
        <View style={styles.signatureSection}>
          <Text style={{fontWeight: 'bold'}}>For {vendorData?.modelNo || '[Vendor Name]'}</Text>
          <Text style={styles.signatureLabel}>Name: {vendorData?.name || '[Name]'}</Text>
          <Text style={styles.signatureLabel}>Title: Authorized Signatory</Text>
          <Text style={styles.signatureLabel}>Date: {new Date().toLocaleDateString()}</Text>
        </View>
 
        <View style={styles.divider} />
 
        <Text style={styles.attachmentTitle}>LIST OF REQUIRED DOCUMENTS FOR VENDOR ONBOARDING</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold'}}>1. Business Registration Documents</Text>
        <Text style={styles.attachmentItem}>- Certificate of Incorporation / Business License</Text>
        <Text style={styles.attachmentItem}>- Partnership Deed (if applicable)</Text>
        <Text style={styles.attachmentItem}>- GST/VAT/TIN registration</Text>
        <Text style={styles.attachmentItem}>- MSME Certificate (if applicable)</Text>
        <Text style={styles.attachmentItem}>- PAN Card</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold', marginTop: 10}}>2. Banking and Financial Information</Text>
        <Text style={styles.attachmentItem}>- Bank Account details with canceled cheque</Text>
        <Text style={styles.attachmentItem}>- Tax Identification Number</Text>
        <Text style={styles.attachmentItem}>- Financial Statements (if required)</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold', marginTop: 10}}>3. Compliance & Regulatory</Text>
        <Text style={styles.attachmentItem}>- Required licenses/permits</Text>
        <Text style={styles.attachmentItem}>- Data Protection agreements (if applicable)</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold', marginTop: 10}}>4. Contracts</Text>
        <Text style={styles.attachmentItem}>- Vendor Agreement</Text>
        <Text style={styles.attachmentItem}>- NDA</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold', marginTop: 10}}>5. Product Documentation</Text>
        <Text style={styles.attachmentItem}>- Product listings and certifications</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold', marginTop: 10}}>6. References (optional)</Text>
        <Text style={styles.attachmentItem}>- Client references / testimonials</Text>
 
        <Text style={{...styles.paragraph, fontWeight: 'bold', marginTop: 10}}>7. Tax Compliance Certificates</Text>
        <Text style={styles.attachmentItem}>- Tax Residency Certificate</Text>
        <Text style={styles.attachmentItem}>- Tax Clearance Certificate</Text>
      </View>
    </Page>
  </Document>
);
 
export default MOUPDF;